"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MyPayCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Helper_1 = require("../Helper");
const PayStubs_1 = __importDefault(require("../api/PayStubs"));
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const MainMenuButton_1 = __importDefault(require("../components/MainMenuButton"));
const MainMenuItem_1 = __importDefault(require("../components/MainMenuItem"));
const Loading_1 = __importDefault(require("../components/Loading"));
const react_i18next_1 = require("react-i18next");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const MaintenanceContext_1 = require("../contexts/MaintenanceContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        label: {
            borderRadius: 2,
            marginTop: 4,
            marginBottom: 3,
            paddingHorizontal: 6,
            paddingVertical: 2
        },
        empty: {
            alignItems: 'center',
            backgroundColor: size != 'sm' ? THEME.UltraLightGray : THEME.SoftGray,
            borderRadius: 4,
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            margin: 3,
            padding: 8
        }
    });
};
function MyPayCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { maintenanceMode, maintenanceCheck } = (0, MaintenanceContext_1.useMaintenanceContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [latest, setLatest] = react_1.default.useState([]);
    const refresh = react_1.default.useCallback(() => {
        if (!maintenanceCheck || maintenanceMode !== "off")
            return;
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => PayStubs_1.default.getLatest(token, 2))).then(data => {
            setLatest(data?.paystubs ?? []);
            setStatus('done');
        }).catch(e => {
            setLatest([]);
            setStatus((e == 404) ? 'done' : 'error');
        });
    }, [maintenanceMode, maintenanceCheck]);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, []);
    const RecentPayStubs = () => react_1.default.useMemo(() => ((0, jsx_runtime_1.jsx)(react_native_1.View, { children: (latest != null && latest?.length > 0)
            &&
                (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', flexWrap: 'wrap', flex: 1 }, children: [latest?.map((item, index, array) => (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: '50%' }, children: (0, jsx_runtime_1.jsxs)(MainMenuButton_1.default, { "aria-label": t('myPay:hints.stub'), accessibilityHint: t('myPay:hints.stubDetail'), onPress: () => props.navigation.navigate('PayStubDetail', { voucherId: item.voucherId, date: item.payDate }), style: { flexDirection: 'column', margin: 3 }, children: [(index == 0)
                                        &&
                                            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.label, { backgroundColor: THEME.Secondary }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.White, fontSize: 10, fontWeight: '500', textAlign: 'center', userSelect: 'none' }, children: t('myPay:text.latest') }) })
                                        ||
                                            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.label, { backgroundColor: THEME.SmokeWhite }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.SmokeWhiteText, fontSize: 10, fontWeight: '500', textAlign: 'center', userSelect: 'none' }, children: t('myPay:text.prev') }) }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: { color: THEME.Text, fontSize: 16, textAlign: 'center', userSelect: 'none' }, children: new Date(item.payDate).toLocaleDateString(Helper_1.Helper.deviceLanguage(), { month: 'short', year: 'numeric', day: 'numeric', timeZone: 'UTC' }) })] }) }, item.voucherId)), (latest?.length % 2 > 0) &&
                            [...Array(2 - (latest.length % 2))].map((_, index) => (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexBasis: '50%' }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.empty, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.MoneyCheckDollar, size: 36, color: THEME.TextDisabled }) }) }, 'paystub-blank-' + index))] })
            ||
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap' }, children: [...Array(2)].map((_, index) => (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexBasis: '50%' }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.empty, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.MoneyCheckDollar, size: 36, color: THEME.TextDisabled }) }) }, 'paystub-blank-' + index)) }) })), [latest]);
    return ((0, jsx_runtime_1.jsx)(Card_1.default, { style: {
            backgroundColor: 'transparent',
            borderWidth: 0,
            borderBottomWidth: 0,
            padding: 0,
            marginTop: 12
        }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { margin: -3 }, children: [(0, jsx_runtime_1.jsx)(MainMenuItem_1.default, { icon: Theme_1.ICONS.Solid.Dollar, disabled: maintenanceCheck && maintenanceMode !== "off", text: t('common:screenTitles.pay'), style: { margin: 3, zIndex: 2 }, onPress: () => props.navigation.navigate('MyPay') }), (status == 'done' && maintenanceCheck)
                    &&
                        (0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: maintenanceMode === "off" && (0, jsx_runtime_1.jsx)(RecentPayStubs, {}) })
                    ||
                        (0, jsx_runtime_1.jsx)(Loading_1.default, { loading: status == 'loading' })] }) }));
}
;
